import React from 'react';
import { Tag, Button, Space, Tooltip } from 'antd';
import { SwapOutlined } from '@ant-design/icons';
import { ROLE_ADMIN, ROLE_USER } from '../roles';
import useRbac from './useRbac';

const ROLE_DISPLAY: Record<string, { label: string; color: string }> = {
  [ROLE_ADMIN]: { label: 'ADMIN', color: 'red' },
  [ROLE_USER]: { label: 'USER', color: 'blue' },
};

/**
 * Header component that shows the user's active role.
 * If the user has multiple roles, it also shows a "Switch Role"
 * button that takes them back to the full-page role selector.
 */
const RoleSwitcher: React.FC = () => {
  const { activeRole, canSwitchRoles, clearRoleSelection } = useRbac();
  const display = ROLE_DISPLAY[activeRole] ?? { label: 'READ ONLY', color: 'default' };

  return (
    <Space size={8}>
      <Tag color={display.color} style={{ marginRight: 0 }}>
        {display.label}
      </Tag>
      {canSwitchRoles && (
        <Tooltip title="Switch to a different role">
          <Button
            type="text"
            size="small"
            icon={<SwapOutlined />}
            onClick={clearRoleSelection}
            style={{ color: 'rgba(255,255,255,0.75)' }}
          >
            Switch Role
          </Button>
        </Tooltip>
      )}
    </Space>
  );
};

export default RoleSwitcher;
